import { AnimatedCollapse } from '@/components/AnimatedCollapse'
import { Button } from '@/components/Button'
import { Word } from '@/domains/Account/modules/Mktu/components'
import { MktuClassWord } from '@/services/Api/generated'
import cn from 'classnames'
import { FunctionComponent } from 'react'
import styles from './SelectedWordsList.module.scss'

interface SelectedWordsListProps {
  className?: string
  listClassName?: string
  isHorizontalOnMobile?: boolean
  words: MktuClassWord[]
  onDelete: (wordName: MktuClassWord['word']) => void
  onShowAll: () => void
  onCollapse?: () => void
  collapsedLimit?: number
  isExpanded?: boolean
  wordMaxWidth?: number | 'auto' | null
  isMultiline?: boolean
}

export const SelectedWordsList: FunctionComponent<SelectedWordsListProps> = ({
  className,
  listClassName,
  isHorizontalOnMobile = false,
  words,
  onDelete,
  onShowAll,
  onCollapse,
  collapsedLimit = 10,
  isExpanded = false,
  wordMaxWidth = 240,
  isMultiline = false,
}) => {
  const visibleWords = isExpanded ? words : words.slice(0, collapsedLimit)

  return (
    <AnimatedCollapse
      className={cn(styles.collapse, className)}
      isVisible={words.length !== 0}
    >
      <div
        className={cn(styles.list, listClassName, {
          [styles.isHorizontalOnMobile]: isHorizontalOnMobile,
        })}
      >
        {visibleWords.map((word) => (
          <Word
            key={word.uuid}
            className={cn(styles.word, {
              [styles.isMultiline]: isMultiline,
            })}
            id={word.word}
            name={word.word}
            onClick={onDelete}
            isNice={word.isNice}
            isDeletable
            isSelected
            maxWidth={wordMaxWidth ?? undefined}
          />
        ))}

        {words.length > collapsedLimit ? (
          <Button
            className={styles.expandButton}
            onClick={isExpanded ? onCollapse : onShowAll}
            variant="ghost"
            size="small"
          >
            {isExpanded ? 'Свернуть' : `+${words.length - collapsedLimit}`}
          </Button>
        ) : null}
      </div>
    </AnimatedCollapse>
  )
}
